import React, { useEffect, useState } from "react";
import { TextArea, Text, ProviderConsumer as FluentUIThemeConsumer, Flex } from "@fluentui/react-northstar";
import { Toggle } from "@fluentui/react";
import { ThemeColorScheme } from "../../common/TeamsTheme";
import { themeNames } from '@fluentui/react-teams';
import { useTranslation } from 'react-i18next';
import { getCachedUsers, searchUsers } from "../../cache/PlatformUserCache";
import { TikitPeoplePicker } from "../PeoplePicker/TikitPeoplePicker";
import { PeoplePicker_UserSourceOptions } from "../../utils/constants";
import { appState } from "../../../AppState";
interface Props {
  ticketApprovalData: Approval,
  setTicketApprovalData: (ticketApprovalData: Approval) => void;
  setApproversList: (value: PlatformUser[]) => void;
}
export const LabelElement = (props: any) => {
  return (
    <div>
      <Flex>
        <Text content={props.label} style={{ display: 'block' }} />
        {props.required && (
          <span style={{ color: 'red', marginLeft: 2 }}>*</span>
        )}
      </Flex>
      <div>{props.children}</div>
    </div>
  );
};
export const ApprovalsForm = ({ ticketApprovalData, setTicketApprovalData, setApproversList }: Props) => {
  const { t } = useTranslation();
  const [switchRecipents, setswitchRecipents] = useState<boolean>(ticketApprovalData.IsRequiredByAll ?? false);
  const [userList, setUserList] = useState(ticketApprovalData.Approvers ? ticketApprovalData.Approvers.map(a => a.Approver) as PlatformUser[] : []);
  const [title, setTitle] = useState<string>();
  const [additionalDetails, setAdditionalDetails] = useState<string>();
  const currentState = appState();
  
  
  useEffect(() => {
    setTitle(ticketApprovalData.Title);
    setswitchRecipents(ticketApprovalData.IsRequiredByAll ?? false);
    setAdditionalDetails(ticketApprovalData.AdditionalDetails);
  }, []);

  useEffect(() => {
    setTicketApprovalData({
      ...ticketApprovalData,
      Title: title,
      IsRequiredByAll: switchRecipents,
      AdditionalDetails: additionalDetails
    });
  }, [switchRecipents, title, additionalDetails]);

  const setApproversPickerData = (approvers: Approver[]) => {
      const getUsers = async () => {
        const users = await getCachedUsers(approvers.map(o => o.Approver.Id));
        setApproversList(users);
      };
      if(approvers.length > 0)
        getUsers();
      else 
        setApproversList([]);
  };
  
  useEffect(() => {
    setApproversPickerData(ticketApprovalData.Approvers);
  }, [ticketApprovalData.Approvers]);

  const setApprovers = async (approvers: PlatformUser[]) => {
    const selectedApprovers = [];
    if (approvers.length > 0) {
      for (let user of approvers) {
        selectedApprovers.push(await searchUsers(user));
      }
      setApproversList(selectedApprovers);
      setUserList(selectedApprovers);
    } else {
      setApproversList([])
      setUserList([]);
    }
  }

  return (
    <FluentUIThemeConsumer
      render={globalTheme => (

        <div
          className="min-h-32"
          style={{
            color: 'var(--mgt-theme-default-foreground)',
            ...ThemeColorScheme(globalTheme.siteVariables)
          }}
        >
          <div >
            <LabelElement label={t('ticket-details.edit-ticket-form.approval.dialog.form.title')} required={true}>
              <TextArea
                maxLength={500}
                required
                fluid
                onChange={(_e, p) => {
                  setTitle(p.value)
                }}
                value={title}
              />
            </LabelElement>
          </div>
          <div>
            <LabelElement label={t('ticket-details.edit-ticket-form.approval.dialog.form.approvers')} required={true} >
              <TikitPeoplePicker 
                options={currentState?.usersInRole}
                value={userList}
                onChange={async (selectedUsers) => await setApprovers(selectedUsers)}
                isMultiple
                globalTheme={globalTheme}
                source={PeoplePicker_UserSourceOptions.EntraMembers}
                />
            </LabelElement>
            <Toggle
              className="pt-2"
              styles={{ label: { color: `${globalTheme.siteVariables.theme === themeNames.Dark ? 'white' : 'black'}` } }}
              label={t('ticket-details.edit-ticket-form.approval.dialog.form.response-requires')}
              {...(switchRecipents && {
                defaultChecked: true,
                style: {
                  background: '#6264a7',
                  opacity: 1
                }
              })}
              inlineLabel
              onChange={(
                _ev: React.MouseEvent<HTMLElement>,
                checked?: boolean
              ) => {
                setswitchRecipents(checked);
              }}
            />
            <div className="pt-1">
              <LabelElement label={t('ticket-details.edit-ticket-form.approval.dialog.form.additional-details')} >
                <TextArea
                  style={{ height: 100 }}
                  fluid
                  onChange={(_e, p) => {
                    setAdditionalDetails(p.value);
                  }}
                  value={additionalDetails}
                />
              </LabelElement>
            </div>
          </div>
        </div>)} />
  )
};